<template>
  <DashboardWidget title="Andamento Fatturato">
    <div class="d-flex h-100 align-items-center justify-content-center flex-column">
      <div class="d-flex align-items-center">
        <i class="fas mr-2" :class="[{ 'text-success fa-caret-up fa-3x' : turnoverTrend > 0 }, { 'text-danger fa-caret-down fa-3x' : turnoverTrend < 0 }, { 'text-dark fa-equals fa-2x' : turnoverTrend === 0 }]"></i>
        <span class="h3 font-weight-light m-0" :class="[{ 'text-success' : turnoverTrend > 0 }, { 'text-danger' : turnoverTrend < 0 }, { 'text-dark' : turnoverTrend === 0 }]">{{ turnoverTrend }}%</span>
      </div>
      <div class="d-flex align-items-center justify-content-around">
        <div class="text-center px-3 border-right">
          <p class="mb-2 lead">Ultimo mese</p>
          <p class="lead m-0">{{ (values.ultimoMese || '-') | money(true) }}</p>
        </div>
        <div class="text-center px-3">
          <p class="mb-2 lead">Media anno</p>
          <p class="lead m-0">{{ (values.mediaAnno || '-') | money(true) }}</p>
        </div>
      </div>
    </div>
  </DashboardWidget>
</template>

<script>

import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  name: 'dashboard-widget-costi',
  filters: {
    money: formatMoneyFilter,
  },
  components: {
    DashboardWidget: () => import('./DashboardWidget'),
  },
  props: {
    values: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      lastMonthTurnover: 19319800,
      yearlyAverage: 16414700,
    };
  },
  computed: {
    turnoverTrend () {
      return this.values.turnoverTrend || 0;
    },
  },
};

</script>
